import { render, staticRenderFns } from "./Multisite.vue?vue&type=template&id=64b9a5ad"
import script from "./Multisite.vue?vue&type=script&lang=js"
export * from "./Multisite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports